import React, { useState, useEffect } from "react";
import {
  TouchableOpacity,
  Text,
  View,
  StyleSheet,
  Platform,
} from "react-native";

import { findIndex } from "lodash";
import AppTheme from "../AppTheme";
import { isWeb } from "../../../helpers/utils";

const DISPLAY_MAP = {
  day: "D",
  week: "W",
  month: "M",
  quarter: "Q",
  year: "Y",
};

export default function Toggle({
  selected,
  options,
  onToggle = () => {},
  style = {},
  selectedStyle = null,
  disabled = [],
}) {
  const [selectedIndex, setSelectedIndex] = useState();

  const selectedPill = selectedStyle // Reflection header
    ? {}
    : {
        backgroundColor: AppTheme.toggle.selected,
        borderRadius: 4,
        zIndex: 10,
      };

  useEffect(() => {
    const foundIndex = findIndex(
      options,
      (t) => t.toLowerCase() == selected?.toLowerCase(),
    );
    setSelectedIndex(foundIndex);
  }, [selected]);

  const handlePress = (option, index) => {
    if (disabled.includes(option) || selectedIndex == index) return;

    setSelectedIndex(index);
    onToggle(option);
  };

  return (
    <View style={[styles.container, style]}>
      {options.map((option, index) => (
        <TouchableOpacity
          activeOpacity={0.5}
          key={index}
          style={[
            styles.option,
            selectedIndex == index ? selectedPill : {},
            index > 0 && styles.pullToLeft,
          ]}
          onPress={() => handlePress(option, index)}
        >
          <Text
            style={[
              styles.text,
              selectedIndex == index
                ? selectedStyle || styles.selectedText
                : {},
            ]}
          >
            {DISPLAY_MAP[option] || option}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 24,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: AppTheme.toggle.bg,
    borderRadius: 4,
    overflow: "hidden",
    minWidth: 160,
    padding: 2,
  },
  option: {
    height: "100%",
    paddingVertical: isWeb ? 6 : 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
    flex: 1,
  },
  text: {
    textTransform: "capitalize",
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.toggle.text,
  },
  selectedText: {
    color: AppTheme.toggle.selectedText,
  },
  pullToLeft: {
    marginLeft: -5,
  },
});
